import { useQuery, UseQueryOptions } from 'react-query'
import { AxiosError } from 'axios'

import { questionsApi } from './questions.api'
import { useRouter } from 'next/router'
import { removeEmptyFilterOptions } from '../filters/filters.utils'
import { components } from '@plandi/common/src/generated'
import { useLocale } from '@plandi/common'

export const useQueryQuestions = <
  T = components['schemas']['FaqQueries'] | undefined
>(
  options?: UseQueryOptions<
    components['schemas']['FaqQueries'] | undefined,
    AxiosError,
    T
  >
) => {
  const router = useRouter()
  const query = removeEmptyFilterOptions(router.query)
  const locale = useLocale()

  const data = useQuery(
    ['Queries', query, locale],
    () => questionsApi.getQuestions(locale, query),
    options
  )

  return data
}
